import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Naudojame TIK User ikoną, nes ji veikia.
import { User } from "lucide-react"; 

/* ===== FIREBASE ===== */
import { db, storage } from "../../firebase"; 
import { collection, query, where, getDocs, limit, documentId, doc, getDoc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

/* ===== I18N ===== */
import i18n from "../../i18n/i18n"; 

// Pagalbinė funkcija adresui (kad rodytų gražiai)
const formatAddress = (addr) => {
    if (!addr) return "";
    if (typeof addr === 'object') {
        const street = addr.street || addr.route || "";
        const city = addr.city || addr.locality || "";
        const zip = addr.zip || addr.postal_code || "";
        return `${street} ${city} ${zip}`.trim();
    }
    return String(addr);
};

// CSS stiliai tiesiogiai JS faile (Saugiausia)
const styles = {
  container: {
    backgroundColor: "#000000",
    minHeight: "100vh",
    width: "100%",
    padding: "0", // Paddingą nuimame čia, dėsime turiniui
    color: "#ffffff",
    boxSizing: "border-box",
    fontFamily: "Arial, sans-serif",
    overflowX: "hidden"
  },
  // LIPNUS HEADERIS
  header: {
    position: "sticky", // Svarbu: Headeris prilimpa viršuje
    top: 0,
    zIndex: 100,
    backgroundColor: "#000000", // Kad turinis nepersišviestų
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #333",
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.5)"
  },
  backBtn: {
    background: "transparent",
    border: "none",
    color: "#D4AF37",
    fontSize: "18px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    padding: 0,
    marginRight: "20px"
  },
  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "bold",
    color: "#ffffff",
    textTransform: "uppercase"
  },
  // TURINYS, KURIS SLENKA
  content: {
    padding: "20px",
    paddingBottom: "50px"
  },
  card: {
    backgroundColor: "#1c1c1e",
    borderRadius: "12px",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    border: "1px solid #333"
  },
  avatarContainer: {
    position: "relative",
    marginRight: "20px"
  },
  avatar: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid #D4AF37",
    backgroundColor: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  section: {
    backgroundColor: "#1c1c1e",
    borderRadius: "12px",
    padding: "20px",
    marginBottom: "15px",
    border: "1px solid #333"
  },
  label: {
    color: "#D4AF37",
    fontSize: "12px",
    textTransform: "uppercase",
    marginBottom: "10px",
    display: "block",
    fontWeight: "bold"
  },
  row: {
    display: "flex",
    alignItems: "center",
    padding: "10px 0",
    borderBottom: "1px solid #333",
    color: "#ccc",
    fontSize: "14px"
  },
  docBtn: {
    display: "flex",
    alignItems: "center",
    padding: "12px",
    backgroundColor: "#2c2c2e",
    borderRadius: "8px",
    color: "#fff",
    textDecoration: "none",
    marginBottom: "8px",
    border: "1px solid #444"
  },
  logoutBtn: {
    width: "100%",
    padding: "15px",
    backgroundColor: "#2c2c2e",
    color: "#ff453a",
    border: "none",
    borderRadius: "12px",
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: "20px",
    cursor: "pointer"
  }
};

const WorkerProfile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const workerId = localStorage.getItem("workerId");
  
  const [workerData, setWorkerData] = useState(null);
  const [companyInfo, setCompanyInfo] = useState({ name: "", address: "" });
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  // KROVIMAS
  useEffect(() => {
    const isRegistered = localStorage.getItem("workerDeviceRegistered") === "true";
    const hasSession = localStorage.getItem("workerGateDone") === "true";

    if (!isRegistered || !hasSession || !workerId) {
      navigate("/worker/login", { replace: true });
      return;
    }

    const loadProfile = async () => {
      try {
        const q = query(collection(db, "workers"), where(documentId(), "==", workerId), limit(1));
        const snap = await getDocs(q);

        if (!snap.empty) {
          const docSnap = snap.docs[0];
          const data = docSnap.data();
          
          setWorkerData({ ...data, id: docSnap.id });

          // Įmonės info (Vardas + Adresas)
          if (data.adminId) {
             try {
                const adminSnap = await getDoc(doc(db, "users", data.adminId));
                if (adminSnap.exists()) {
                   const aData = adminSnap.data();
                   setCompanyInfo({ 
                       name: aData.companyName || aData.company || "", 
                       address: formatAddress(aData.address) // Paimame suformatuotą adresą
                   });
                }
             } catch (e) { console.log(e); }
          }
        }
      } catch (e) {
        console.error("Error:", e);
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [workerId, navigate]);

  // Nuotrauka
  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files[0] && workerId) {
      const file = e.target.files[0];
      setUploading(true);
      try {
        const storageRef = ref(storage, `profile_pics/${workerId}/${Date.now()}_${file.name}`);
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);
        await updateDoc(doc(db, "workers", workerId), { profilePic: url });
        setWorkerData(prev => ({ ...prev, profilePic: url }));
      } catch (err) {
        alert("Upload Error");
      } finally {
        setUploading(false);
      }
    }
  };

  const handleLogout = () => {
    localStorage.setItem("workerGateDone", "false"); 
    navigate("/worker/login", { replace: true });
  };

  if (loading) return <div style={{...styles.container, display:'flex', justifyContent:'center', paddingTop:'100px'}}>Wait...</div>;

  return (
    <div style={styles.container}>
      
      <input type="file" ref={fileInputRef} style={{ display: "none" }} accept="image/*" onChange={handleFileChange} />

      {/* STICKY HEADER */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>
           &#8592; {t('back') || "Back"}
        </button>
        <h2 style={styles.title}>{t('profile') || "Profile"}</h2>
      </div>

      {/* TURINYS (Slenka po apačia) */}
      <div style={styles.content}>
        
        {/* KORTELĖ */}
        <div style={styles.card}>
            <div style={styles.avatarContainer} onClick={() => fileInputRef.current && fileInputRef.current.click()}>
                <div style={styles.avatar}>
                {workerData?.profilePic ? (
                    <img src={workerData.profilePic} alt="Profile" style={{width:'100%', height:'100%', borderRadius:'50%', objectFit:'cover'}} />
                ) : (
                    <User size={30} color="#D4AF37" />
                )}
                </div>
                <div style={{position:'absolute', bottom:0, right:0, background:'#000', borderRadius:'50%', padding:'2px', border:'1px solid #D4AF37', fontSize:'12px'}}>
                    📷
                </div>
                {uploading && <div style={{position:'absolute', top:0, left:0, width:'100%', height:'100%', background:'rgba(0,0,0,0.7)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'10px'}}>...</div>}
            </div>
            <div style={{flex: 1}}>
                <div style={{fontSize:'18px', fontWeight:'bold', color:'#fff'}}>
                    {workerData?.fields?.name || workerData?.name || "Worker"}
                </div>
                {/* ĮMONĖS PAVADINIMAS */}
                <div style={{fontSize:'13px', color:'#888', marginTop:'5px'}}>
                    {companyInfo.name && <span>🏢 {companyInfo.name}</span>}
                </div>
                {/* ĮMONĖS ADRESAS */}
                <div style={{fontSize:'12px', color:'#666', marginTop:'2px'}}>
                    {companyInfo.address && <span>📍 {companyInfo.address}</span>}
                </div>
            </div>
        </div>

        {/* ASMENINIAI DUOMENYS */}
        <div style={styles.section}>
            <span style={styles.label}>{t('personal_data') || "Personal Data"}</span>
            
            {(workerData?.email || workerData?.fields?.email) && (
                <div style={styles.row}>✉️ &nbsp; {workerData.email || workerData.fields.email}</div>
            )}
            {(workerData?.phone || workerData?.fields?.phone) && (
                <div style={styles.row}>📞 &nbsp; {workerData.phone || workerData.fields.phone}</div>
            )}

            {/* Custom fields */}
            {workerData?.customFields && Array.isArray(workerData.customFields) && workerData.customFields.map((field, idx) => (
                <div key={idx} style={styles.row}>
                    <span style={{color:'#888', marginRight:'10px'}}>{field.label}:</span> {field.value}
                </div>
            ))}
            
            <div style={{marginTop:'10px', fontSize:'11px', color:'#555', fontStyle:'italic'}}>
                {t('data_managed_by_admin') || "Data managed by admin"}
            </div>
        </div>

        {/* DOKUMENTAI (GRAŽINTA SU APSAUGA) */}
        {workerData?.documents && Array.isArray(workerData.documents) && workerData.documents.length > 0 && (
            <div style={styles.section}>
                <span style={styles.label}>{t('documents') || "Documents"}</span>
                {workerData.documents.map((docItem, idx) => (
                    <a key={idx} href={docItem.url} target="_blank" rel="noreferrer" style={styles.docBtn}>
                        <span style={{fontSize: '18px', marginRight: '10px'}}>📄</span>
                        <span style={{color: '#D4AF37'}}>{docItem.name || "Document"}</span>
                    </a>
                ))}
            </div>
        )}

        {/* KALBA */}
        <div style={styles.section}>
            <span style={styles.label}>{t('language') || "Language"}</span>
            <select 
                value={i18n.language} 
                onChange={(e) => { i18n.changeLanguage(e.target.value); localStorage.setItem("language", e.target.value); }}
                style={{width:'100%', padding:'10px', backgroundColor:'#000', color:'#fff', border:'1px solid #333', borderRadius:'8px'}}
            >
                <option value="en">🇬🇧 English</option>
                <option value="de">🇩🇪 Deutsch</option>
                <option value="lt">🇱🇹 Lietuvių</option>
                <option value="ru">🇷🇺 Русский</option>
                <option value="ro">🇷🇴 Română</option>
                <option value="bg">🇧🇬 Български</option>
                <option value="nl">🇳🇱 Nederlands</option>
            </select>
        </div>

        {/* ATSIJUNGTI */}
        <button style={styles.logoutBtn} onClick={handleLogout}>
            🚪 {t('logout') || "Log Out"}
        </button>

      </div>
    </div>
  );
};

export default WorkerProfile;